import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { DATOS_API } from 'app/auth/auth.datos';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';

@Component({
  selector: 'app-introduccion',
  templateUrl: './introduccion.component.html',
  styleUrls: ['./introduccion.component.scss'],
  animations : fuseAnimations
})
export class IntroduccionComponent implements OnInit {
  logo:any;
  urlApi:any;

  constructor(
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    if(localStorage.getItem("ctProductoId")){
      this.getDatosEmpresa();
    }
    else{
      this.getDatosEmpresaCentroTrabajo();
    }
  }

  getDatosEmpresa(){
    this.wizardService.getDatosEmpresa().subscribe( (datos: backInter.infoEmpresa) => {
      // console.log(datos.data.logoEmpresa);
      this.urlApi=DATOS_API.url.substring(0,(DATOS_API.url.length-5));
      this.logo=this.urlApi+'/surveyadministrator/backend/'+datos.data.logoEmpresa;
    });
  }

  getDatosEmpresaCentroTrabajo(){
    this.wizardService.getDatosEmpresaCentroTrabajo(localStorage.getItem('empresaPadre')).subscribe( (datos: backInter.infoEmpresa) => {
      // console.log(datos);
      this.urlApi=DATOS_API.url.substring(0,22);
      this.logo=this.urlApi+'/surveyadministrator/backend/'+datos.data.logoEmpresa;
    });
  }

}
